<template>
  <div id="curriculum" v-title data-title="雅思课程_雅思培训课程_雅思在线课程_雅思公开课 - 羊驼雅思官网">

    <Head :headerNum="4" />
    <div class="content">
      <div class="open-course">
        <div class="container-title">优秀公开课</div>
        <div class="course-content">
          <div class="course-list">
            <div class="card-img" v-for="(item, index) in courseData" :key="index">
              <a :href="`/openclass?id=${item.id}`">
                <img :src="item.outsideUrl" alt />
              </a>
            </div>
          </div>
          <a href="/openclass" class="test-more">更多课程 >></a>
        </div>
      </div>
      <div class="quality-course">
        <div class="container-title-2">羊驼优质<strong>课程</strong></div>
        <div class="container-title-3">在羊驼课堂，多方位跟踪学习效果</div>
        <div class="course-content">
          <div class="course-list list-2">
            <router-link :to="{ path: '/curriculum-detail', query: { id: item.id } }" class="c-item"
              v-for="(item, index) in qualityCourse" :key="index">
              <img :src="item.img" alt="" />
              <div class="c-txt">
                <div class="c-name">{{ item.name }}</div>
                <div class="c-title" v-for="(item2, index2) in item.title" :key="index2">
                  {{ item2 }}
                </div>
              </div>
              <router-link class="c-more" :to="{ path: '/curriculum-detail' }">了解更多</router-link>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ajax from "./../../api/ajax";
import Head from "./../../components/Head";
export default {
  name: "Curriculum",
  components: {
    Head
  },
  data() {
    return {
      courseData: [],
      qualityCourse: [
        {
          id: 1,
          name: "全科基础班",
          title: ["基础薄弱适用", "三阶段课程提升英语核心力"],
          img: "/static/img/ielts_1.png"
        },
        {
          id: 2,
          name: "全科训练营",
          title: ["魔鬼训练营", "1vs1式全程督学", ""],
          img: "/static/img/ielts_2.png"
        },
        {
          id: 3,
          name: "全科冲刺班",
          title: ["实用的技巧集训", "全程小班直播互动", "提升基本功"],
          img: "/static/img/ielts_3.png"
        },
        {
          id: 4,
          name: "1V1规划班",
          title: [
            "针对弱项量身设置课程内容",
            "根据吸收程度调节授课节奏",
            "公认效率喜人的学习形式!"
          ],
          img: "/static/img/ielts_4.png"
        }
      ]
    };
  },
  async mounted() {
    const courseList = await ajax(
      "/api/course/listByIds",
      [102, 47, 57, 53],
      "POST"
    );
    this.courseData = courseList.data.list;
  }
};
</script>

<style lang="stylus" scoped>
.content {
  width: 100%;
  margin: 64px auto 0 auto;
  .quality-course{
    padding:40px 0 50px;
    background-color: #fbfaff;
    .container-title-2{
      text-align: center;
      margin-bottom: 20px;
      font-family:"思源黑体";
      font-size: 27.9975px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2.8px;
      color: #333333;
    }
    .container-title-3{
      text-align: center;
      margin-bottom: 20px;
      font-family:"思源黑体";
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #666666;
    }
  }
  .open-course{
    padding:40px 0 30px;
    .container-title{
      text-align: center;
      margin-bottom: 20px;
      font-family:"思源黑体";
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;
    }
  }
  .course-content{
    max-width 1200px;
    margin 0 auto;
    overflow hidden;
  }

  .test-more {
    float: right;
    padding-right: 20px;
    font-weight: bold;
  }
  .list-2{
    display flex;
    justify-content center;
    align-items center;
  }
  .c-more{
    border-top:1px solid #f2f2f2;
    padding:10px 20px;
    display block;
    font-family:"思源黑体";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #7d5fe6;
  }
  .c-title{
    height:24px;
    font-family:"思源黑体";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #333333;
  }
  .c-name{
    font-family:"思源黑体";
    font-size: 20px;
    font-weight: 700;
    font-stretch: normal;
    letter-spacing: 4px;
    color: #333333;
    margin-bottom 10px;
  }
  .c-txt{
    display flex;
    flex-flow:column;
    justify-content center;
    align-items center;
    margin 20px 0;
  }
  .course-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .c-item{
      width: 260px;
      background-color: #ffffff;
      box-shadow: 2px 4px 6px 0px rgba(0, 0, 0, 0.04);
      border-radius: 2.5px;
      cursor pointer;
    }
    .card-img {
      transition: all 0.3s ease;
    }
    .card-img:hover {
      margin-top: -30px;
    }
  }
}
@media only screen and (max-width:1024px){
  .open-course,.quality-course{
    padding:30px 0!important;
  }
  .container-title{
    font-size:18px!important;
  }
  .container-title-2{
    font-size:16px!important;
    margin-bottom:10px!important;
  }
  .container-title-3{
    font-size: 9px!important;
    width:90%;
    margin 0 auto;
  }
  .c-item{
    width 48%!important;
    margin-bottom 15px;
  }
  .c-more{
    font-size 9px!important;
  }
  .c-name{
    font-size: 10px!important;
  }
  .c-title{
    width: 90%;
    text-align center;
    font-size:7px!important;
    overflow hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .course-content{
    width 90%;
  }
  .course-list{
    flex-wrap: wrap;
  }
  .card-img{
    width 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Curriculum/Curriculum.vue